import { isEmpty } from '../../utils/isEmpty.js';
const isSingularFieldMatch = (key, pattern) => (target) => isEmpty(pattern[key]) || isEmpty(target[key]) || pattern[key] === target[key];
const isMultipleFieldMatch = (key, pattern) => (target) => isEmpty(pattern[key]) ||
    isEmpty(target[key]) ||
    pattern[key]?.every((_) => target[key]?.includes(_));
const isNumberFieldMatch = (key, pattern) => (target) => isEmpty(pattern[key]) ||
    isEmpty(target[key]) ||
    naturalNumber(pattern[key]) <= naturalNumber(target[key]);
const isMultipleNumberFieldMatch = (key, pattern) => (target) => isEmpty(pattern[key]) || isEmpty(target[key]) || target[key]?.includes(pattern[key]);
const isValueInRange = (key, pattern) => (target) => isEmpty(pattern[key]) ||
    isEmpty(target[key]) ||
    (naturalNumber(pattern[key]?.min) >= naturalNumber(target[key]?.min) &&
        naturalNumber(pattern[key]?.min) <= naturalNumber(target[key]?.max));
export const targetMatchPattern = (pattern, target) => Object.entries(pattern)
    .map(([key, subPattern]) => {
    if (typeof subPattern === 'number') {
        return Array.isArray(target[key])
            ? isMultipleNumberFieldMatch(key, pattern)
            : isNumberFieldMatch(key, pattern);
    }
    if (typeof subPattern === 'object' && 'min' in subPattern && 'max' in subPattern) {
        return isValueInRange(key, pattern);
    }
    return Array.isArray(subPattern)
        ? isMultipleFieldMatch(key, pattern)
        : isSingularFieldMatch(key, pattern);
})
    .every((predicate) => predicate(target));
const naturalNumber = (n) => Number(n || 0);
//# sourceMappingURL=targetMatchPattern.js.map